import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from '../../../shared';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { delay, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class cmsServiceMapperResolver implements Resolve<any> {
  constructor(private httpClient: HttpClient) { }
  private endPoints = SERVICE_END_POINT.higherEnvironment;

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    let screenToFetch: string;
    let cmsJsonUrl: string;
    let resultData: any;
    switch (state.url) {
      case '/quote/your-product-quote': {
        screenToFetch = 'CMS_YourProductQuote';
        cmsJsonUrl = this.endPoints[screenToFetch];
        resultData = this.getCMSData(cmsJsonUrl);
        break;
      }
      case '/quote/your-saved-quotes': {
      resultData = this.getMultipleCMSData();
      break;
      }
      case '/apply/your-pension-savings': {
        screenToFetch = 'CMS_YourPensionSavingsApply';
        cmsJsonUrl = this.endPoints[screenToFetch];
        resultData = this.getCMSData(cmsJsonUrl);
        break;
      }
      case '/apply/your-product-application': {
        screenToFetch = 'CMS_YourProductApplication';
        cmsJsonUrl = this.endPoints[screenToFetch];
        resultData = this.getCMSData(cmsJsonUrl);
        break;
      }
      case'/apply/your-product-application?view=true': {
        screenToFetch = 'CMS_YourProductApplication';
        cmsJsonUrl = this.endPoints[screenToFetch];
        resultData = this.getCMSData(cmsJsonUrl);
        break;
      }
    }
    return resultData;
  }

  getCMSData(cmsJsonUrl): Observable<any> | Promise<any> | any {
    return this.httpClient.get(cmsJsonUrl).toPromise().then(res => {
      if (res) {
        //console.log(res);
        return res;
      }
    });
  }
  getMultipleCMSData(): Observable<any> | Promise<any> | any {
    let savedQuotes = this.getCMSData(this.endPoints.CMS_YourSavedQuotes);
    let cancelApp = this.getCMSData(this.endPoints.CMS_ShortModal_CancelApp);
    let quoteExpiry = this.getCMSData(this.endPoints.CMS_ShortModal_AppQuoteExp);
    let newQuote = this.getCMSData(this.endPoints.CMS_ShortModal_NewQuote);
    let productQuote = this.getCMSData(this.endPoints.CMS_YourProductQuote);
    return forkJoin([savedQuotes, cancelApp, quoteExpiry, newQuote, productQuote]).pipe(map((results) => {
      return {
        saveQuotes: results[0],
        cancelApp: results[1],
        quoteExpiry: results[2],
        newQuote: results[3],
        productQuote: results[4]
      };
    }));
  }
}
